import type { SlideFields } from "@/types/Slide";
import type { GrammarSlideData } from "@ai-teach/types";
import { AiFillPicture } from "react-icons/ai";
import { HiVolumeUp } from "react-icons/hi";
import { IoMdArrowBack } from "react-icons/io";

interface GrammarSentenceThumbnailProps {
  slide: SlideFields;
}

export function GrammarSentenceThumbnail({ slide }: GrammarSentenceThumbnailProps) {
  const { text, image, correctAnswer } = slide.slideData as GrammarSlideData;

  return (
    <div className="bg-orange-50 h-full flex flex-col px-2 py-1.5 gap-4  overflow-hidden">
      {/* Image */}
      <div className="w-full aspect-square rounded-lg overflow-hidden border-2 border-orange-400 bg-white shrink-0">
        {image?.src ? (
          <img src={image.src} alt={text || "image"} className="w-full h-full object-cover" />
        ) : (
          <div className="w-full h-full flex items-center justify-center bg-orange-50">
            <AiFillPicture className="text-orange-200 text-lg" />
          </div>
        )}
      </div>

      {/* Question card */}
      <div className="bg-white rounded-lg overflow-hidden flex shrink-0 shadow-sm">
        <div className="bg-orange-400 flex items-center justify-center px-2 shrink-0">
          <span
            className="text-white font-black leading-none"
            style={{ fontSize: "7px", letterSpacing: "0.05em" }}
          >
            Q
          </span>
        </div>
        <p className="text-[8px] font-semibold text-gray-700 leading-tight line-clamp-2 flex-1 px-2 py-1.5">
          {text || "No sentence"}
        </p>
      </div>

      {/* Answer card */}
      <div className="bg-white rounded-lg overflow-hidden flex shrink-0 shadow-sm">
        <p className="text-[8px] font-semibold leading-tight text-black line-clamp-2 flex-1 px-2 py-1.5">
          {correctAnswer || "No answer"}
        </p>
        <div className="bg-orange-700 flex items-center justify-center px-2 shrink-0">
          <span
            className="text-white font-black leading-none"
            style={{ fontSize: "7px", letterSpacing: "0.05em", opacity: 0.9 }}
          >
            A
          </span>
        </div>
      </div>
    </div>
  );
}
